import { Icon } from "./Icon.tsx";

/** ToolsMenu.tsx's own "trace downstream" action icon — two upstream branches converging into one, flowing down to a chevron arrowhead (the same converging-network shape traceNetwork.ts's own BFS follows). */
export function TraceDownstreamIcon() {
  return (
    <Icon>
      <circle cx="6" cy="5" r="1.6" />
      <circle cx="18" cy="5" r="1.6" />
      <path d="M6 6.5 L12 12 M18 6.5 L12 12 M12 12 L12 17 M8.5 14.5 L12 18 L15.5 14.5" />
    </Icon>
  );
}
